import ksaFlag from "@/assets/ksa-flag.png";
import uaeFlag from "@/assets/uae-flag.png";
import {
  SAUDI_ARABIA_COUNTRY_CODE,
  BAHRAIN_COUNTRY_CODE,
  UNITED_ARAB_EMIRATES_COUNTRY_CODE,
} from "../constants/countries";

interface Country {
  code: string;
  prefix: string;
  flag: any;
  name: string;
}

type CountryCode =
  | typeof SAUDI_ARABIA_COUNTRY_CODE
  | typeof BAHRAIN_COUNTRY_CODE
  | typeof UNITED_ARAB_EMIRATES_COUNTRY_CODE;

export const countries: Country[] = [
  {
    code: SAUDI_ARABIA_COUNTRY_CODE,
    prefix: "00966",
    flag: ksaFlag,
    name: "+966",
  },
  {
    code: UNITED_ARAB_EMIRATES_COUNTRY_CODE,
    prefix: "00971",
    flag: uaeFlag,
    name: "+971",
  },
];

export { CountryCode, Country };
